if (is_route('record_data.index')) {
    $(document).on('bss:onload', function() {
        record_data_event_set();
    });
}
// Webview用の画面の場合、イベント初期化を行う
else if (is_route('api.cm.rollcall.get_warning_video_html')) {
    // 読み込み完了後にイベント初期化
    $(function() {
        record_data_modal_event_set();
    });
}

// === 全画面切り替え（ページロード時に1回だけバインド） ===
(function() {
    if (window._videoFullscreenBound) return;
    window._videoFullscreenBound = true;

    var fsElement = function() {
        return document.fullscreenElement
            || document.webkitFullscreenElement
            || document.msFullscreenElement;
    };
    var requestFs = function(el) {
        if (el.requestFullscreen) return el.requestFullscreen();
        if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
        if (el.msRequestFullscreen) return el.msRequestFullscreen();
    };
    var exitFs = function() {
        if (document.exitFullscreen) return document.exitFullscreen();
        if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
        if (document.msExitFullscreen) return document.msExitFullscreen();
    };

    // メイン動画を直接全画面化（ネイティブコントロール表示）
    $(document).on('click', '.video-fullscreen-btn', function() {
        var mainVideo = document.getElementById('main-video');
        if (!mainVideo) return;

        if (!fsElement()) {
            mainVideo.setAttribute('controls', '');
            requestFs(mainVideo);
        } else {
            exitFs();
        }
    });

    function onFullscreenChange() {
        var btn = document.querySelector('.video-fullscreen-btn i');
        var mainVideo = document.getElementById('main-video');
        if (btn) {
            btn.className = fsElement() ? 'fa fa-compress' : 'fa fa-expand';
        }
        // 全画面解除時: ネイティブコントロールを消し、全 video / audio の再生位置と再生状態を main-video に揃える
        if (!fsElement() && mainVideo) {
            mainVideo.removeAttribute('controls');
            var wasPlaying = !mainVideo.paused;
            // ドリフト防止: main-video が再生中なら直接 pause（ネイティブコントロール経由の play promise は既に解決済みのはずなので AbortError は出ない）
            mainVideo.pause();
            // モーダル側の状態を「全停止 / isPlaying=false / ボタン=再生表示」にリセット
            // （wasPlaying=true 後続の #video-play 経路で play() が確実に走らせるため isPlaying を一旦下げる）
            $('#video-pause').trigger('click');
            // 全 video / audio に main-video の currentTime を伝播
            var currentTime = mainVideo.currentTime;
            document.querySelectorAll('.in-vehicle-video').forEach(function(video) {
                if (video !== mainVideo) {
                    video.currentTime = currentTime;
                }
            });
            var audio = document.getElementById('in-vehicle-audio');
            if (audio) {
                audio.currentTime = currentTime;
            }
            // 再生中だった場合は #video-play 経由で全 video / audio を再生再開
            // （play() 呼び出しは1経路に集約され、AbortError 系の race も最小化される）
            if (wasPlaying) {
                $('#video-play').trigger('click');
            }
            // シークバー・現在時間表示・地図マーカーは timeline-video の timeupdate 駆動のため、明示的に発火させる
            var timeline = document.getElementById('timeline-video');
            if (timeline) {
                timeline.dispatchEvent(new Event('timeupdate'));
            }
        }
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    document.addEventListener('MSFullscreenChange', onFullscreenChange);
})();

window.record_data_event_set = function () {
    /* 検索関連 */

    //日報単位に変更した際に親formが発火しないようにする
    $(document).on('change', '#search-form-unit_basic_summary', function(e) {
        e.preventDefault();
        e.stopPropagation();
        switchingDateLabel();
    });

    //動画単位に変更した際に親formが発火しないようにする
    $(document).on('change', '#search-form-unit_warning', function(e) {
        e.preventDefault();
        e.stopPropagation();
        switchingDateLabel();
    });

    //検索開始日時
    $(document).on('change', '#search-form-start_time', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let last_day = null;
        selected_date = $(this).val();
        set_end = $('#search-form-end_time').val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31,selected_date.getHours(),selected_date.getMinutes());
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate(),selected_date.getHours(),selected_date.getMinutes());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate(),set_end.getHours(),set_end.getMinutes());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0" + ( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + yyyymmdd.getDate() ).slice(-2);
                $('#search-form-end_time').val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                 last_day = chk_date.getFullYear()+'/'+
                        ( "0" + ( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + chk_date.getDate() ).slice(-2) ;
                $('#search-form-end_time').val(last_day);
            }
        }

    });

    //検索終了日時
    $(document).on('change', '#search-form-end_time', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let last_day = null;
        selected_date = $(this).val();
        set_start = $('#search-form-start_time').val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31,set_start.getHours(),set_start.getMinutes());
            yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate(),set_start.getHours(),set_start.getMinutes());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0" + ( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + yyyymmdd.getDate() ).slice(-2);
                $('#search-form-start_time').val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                last_day = selected_date.getFullYear()+'/'+
                        ( "0" + ( selected_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0" + selected_date.getDate() ).slice(-2);
                $('#search-form-start_time').val(last_day);
            }
        }
    });

    // 全て選択用のチェックボックス
    $(document).on('change', '#all-select-btn', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).prop('checked')) {
            //個別のイベント種別チェックボックスからチェックを外して、非選択状態の状態にする
            $('.event_type-check').prop('checked', false);
        }else {
            // 自分自身のチェックは外させない(全て選択のチェックが外れるのは個別チェックボックスの押下時のみ)
            $(this).prop('checked', true);
        }
    });

    // イベント種別の個別チェックボックス
    $(document).on('change', '.event_type-check', function(e) {
        e.preventDefault();
        e.stopPropagation();
        // 全て選択チェックボックスが選択状態だったら、非選択状態にする
        if ($('#all-select-btn').prop('checked')) {
            $('#all-select-btn').prop('checked', false);
        }
        if($('.event_type-check:checked').length <= 0) {
            //全てのチェックボックスのチェックが外れていたら全て選択を選択状態にする
            $('#all-select-btn').prop('checked', true);
        }
    });

    //タグフォームの内容が変更された際に親formを発火させないようにする
    $(document).on('change', '#search-form-tag_id', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //コメントフォームの内容が変更された際に親formを発火させないようにする
    $(document).on('change', '#search-form-comment', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //車両名フォームの内容が変更された際に親formを発火させないようにする
    $(document).on('change', '#search-form-vehicle_id', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //乗務員名フォームの内容が変更された際に親formを発火させないようにする
    $(document).on('change', '#search-form-driver_id', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //撮影地点フォームの内容が変更された際に親formを発火させないようにする
    $(document).on('change', '#search-form-place_name', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //要求中動画一覧表示ON/OFFフォームの内容が変更された際に親formを発火させないようにする
    $(document).on('change', '#search-form-requesting_video_list_view', function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    //検索ボタンクリックでformを動作させる
    $(document).on('click','#search-btn', function(event) {
        //グループ会社が選択されていない場合検索は行わない。
        if( $('input[name="holding_id"]').length > 0) {
            let callback = null;
            let isExtendPageQuery =  true;
            let selector = '#search-form';
            let replaceSelector = '#contents';
            // チェックボックスの状態をクエリパラメータに反映させる
            let action = $(selector).prop('action');
            $('.event_type-check').each(function() {
                if (!$(this).prop('checked')) {
                    _request.remove_parameters(action, [$(this).prop('name')]);
                }
            });
            $(selector).prop('action', action);
            //リスト更新
            load_contents(callback, isExtendPageQuery, selector, replaceSelector, false);
        }
    });

    // 動画表示用モーダルを表示する
    $(document).on('click', '[data-video-modal]', function () {
        _modal.create(this, 'video-modal', ['warning_id','record_id','holding_id','company_id','unit'], false, function(){
            record_data_modal_event_set();
        });
    });

    //日時用フォームのラベルを動的に変更する
    function switchingDateLabel() {
        var labelText = $('.unit-label').text();
        $('.unit-label').text($('.unit-label').data('text'));
        $('.unit-label').data('text',labelText);
    }

    /* ファイルダウンロード関連 */
    //全選択・全解除
    $(document).on('change','#warning_all_select',function () {
        if ($(this).prop('checked')) {
            // リスト内全ての選択用チェックボックスにチェックを付ける
            $('.check_warning_data').prop('checked', true);
        }else {
            // リスト内全ての選択用チェックボックスにチェックを外す
            $('.check_warning_data').prop('checked', false);
        }
    });

    // CSVダウンロード
    $(document).on('click', '#search-form-csv_download', function () {
        if($('input[name="holding_id"]').length <= 0) {
            toastr.warning('グループ会社が選択されていません。');
        } else if($('input[name="check_warning_data[]"]:checked').length <= 0) {
            toastr.warning('一覧からダウンロードしたい動画にチェックをしてください。');
        } else {
            // アクションの取得
            let action = extend_url_query($(this).data('action'));
            // 一覧にあるデータのチェックされたものを配列化する
            let ids = $('input[name="check_warning_data[]"]:checked').map(function() {
                return $(this).val();
            }).get();
            let datas = [
                {name:'_token',value:$('input[name="_token"]').val()},
                {name:'holding_id',value:$('input[name="holding_id"]').val()},
                {name:'ids',value:ids},
            ];
            // 送信
            post(action, datas);
        }
    });

    // 動画ダウンロード
    $(document).on('click', '#search-form-video_download', function () {
        if($('input[name="holding_id"]').length <= 0) {
            toastr.warning('グループ会社が選択されていません。');
        } else if($('input[name="check_warning_data[]"]:checked').length <= 0) {
            toastr.warning('一覧からダウンロードしたい動画にチェックをしてください。');
        } else {
            // アクションの取得
            let action = extend_url_query($(this).data('action'));
            // 一覧にあるデータのチェックされたものを配列化する
            let ids = $('input[name="check_warning_data[]"]:checked').map(function() {
                return $(this).val();
            }).get();
            let datas = [
                {name:'_token',value:$('input[name="_token"]').val()},
                {name:'holding_id',value:$('input[name="holding_id"]').val()},
                {name:'ids',value:ids},
            ];
            // 送信
            $.ajax({
                url: action,
                type: 'POST',
                data: datas,
                xhrFields: {
                    responseType: 'blob' // レスポンスをBlobとして処理する
                },
                success: function(data, status, xhr) {
                    const disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        const filename = disposition.split('filename=')[1].split(';')[0].replace(/['"]/g, '');
                        const blob = new Blob([data], { type: xhr.getResponseHeader('Content-Type') });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        toastr.error('File download failed.');
                    }
                },
                error: function(jqXHR) {
                    const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                    toastr.error('Error: ' + errorMessage);
                }
            });
        }
    });

    // // 要求中動画ボタン
    // $(document).on('click', '[data-requesting-video-list-modal]', function(e) {
    //     _modal.create(this, 'requesting-video-list-modal', ['holding_id', 'company_id', 'section_id']);
    // });

    // タグ・コメント編集用のモーダルを表示する
    $('[data-tagCommentEdit-modal]').off('click');
    $(document).on('click', '[data-tagCommentEdit-modal]', function () {
        //warningテーブルからデータを取得する
        let action = extend_url_query($(this).data('action'));
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'warning_id',value:$('#tag_comment_edit-btn').data('warning_id')},
            {name:'holding_id',value:$('input[name="holding_id"]').val()},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                let tagArray = [];
                let tags = data.tag;
                tags.forEach(function(tag) {
                    tagArray.push(tag);
                })
                $('#editform-tag').val(tagArray).trigger('change');
                $('#editform-comment').val(data.comment);
                _modal.show('#tagCommentEdit-modal');
            },
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                toastr.error('Error: ' + errorMessage);
            }
        });
    });

    let editFormId = '#editform-';
    //タグ・コメントをDBに登録する
    $(document).on('click', '#editform-submit', function () {
        $(editFormId + 'tag').removeClass('is-invalid');
        $(editFormId + 'tag-errors').children('span').addClass('copy').text('');
        $(editFormId + 'comment').removeClass('is-invalid');
        $(editFormId + 'comment-errors').children('span').addClass('copy').text('');
        let action = extend_url_query($(this).data('action'));
        let multipleselect = [];
        $('#editform-tag option:selected').each(function() {
            multipleselect.push($(this).val());
        });
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'warning_id',value:$('#tag_comment_edit-btn').data('warning_id')},
            {name:'holding_id',value:$('input[name="holding_id"]').val()},
            {name:'inputTag',value:$('#editform-tag').val()},
            {name:'inputComment',value:$('#editform-comment').val()},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                toastr.success(data.message);
            },
            error: function(xhr) {
                $.each(xhr.responseJSON.errors, function(name, message) {

                    $(editFormId + name).addClass('is-invalid');
                    $(editFormId + name +'-errors').children('span').removeClass('copy').text(message);
                });
                const errorMessage = xhr.responseJSON.subject ? xhr.responseJSON.subject : 'エラー内容を確認してください。';
                toastr.error(errorMessage);
            }
        });
    });

    $('#editform-tag_plus').off('click');
    $(document).on('click', '#editform-tag_plus', function () {
        //タグデータの登録を行う
        let action = extend_url_query($(this).data('action'));
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'warning_id',value:$('#tag_comment_edit-btn').data('warning_id')},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                $('#add_tag-modal').find('.modal-content').empty();
                $('#add_tag-modal').find('.modal-content').append(data);
                _modal.show('#add_tag-modal');
            },
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                toastr.error('Error: ' + errorMessage);
            }
        });
    });

    //タグの追加処理
    let addFormId = '#tag_add_form-';
    $(document).on('click', '#tag_add_form-submit', function () {
        $(addFormId + 'holding_id').removeClass('is-invalid');
        $(addFormId + 'holding_id-errors').children('span').addClass('copy').text('');
        $(addFormId + 'company_id').removeClass('is-invalid');
        $(addFormId + 'company_id-errors').children('span').addClass('copy').text('');
        $(addFormId + 'content1').removeClass('is-invalid');
        $(addFormId + 'content1-errors').children('span').addClass('copy').text('');
        let action = extend_url_query($(this).data('action'));
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'holding_id',value:$(addFormId + 'holding_id').val()},
            {name:'company_id',value:$(addFormId + 'company_id').val()},
            {name:'content1',value:$(addFormId + 'content1').val()},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                $('#editform-tag').append($('<option>').html(data.content1).val(data.id));
                toastr.success(data.message);
            },
            error: function(xhr) {
                $.each(xhr.responseJSON.errors, function(name, message) {
                    $(addFormId + name).addClass('is-invalid');
                    console.log(addFormId + name);
                    $(addFormId + name +'-errors').children('span').removeClass('copy').text(message);
                });
                const errorMessage = xhr.responseJSON.subject ? xhr.responseJSON.subject : 'エラー内容を確認してください。';
                toastr.error(errorMessage);
            }
        });
    });

    /**
     * 動画要求ボタン押下時イベントの処理を行います。
     */
    $(document).on( "click", '#modal_request_video_button', function(){
        /** 動画要求処理 */
        execRequestVideo(0);
    });
    $(document).on( "click", '#modal_request_video_prev20_button', function(){
        /** 動画要求処理 */
        execRequestVideo(-15);
    });
    $(document).on( "click", '#modal_request_video_next20_button', function(){
        /** 動画要求処理 */
        execRequestVideo(15);
    });

    /**
     * 動画要求を実行します。
     * @param {*} settings
     */
    function execRequestVideo(diff){
        // 動態要求データ登録処理を実行
        let req_time = new Date($('#request_btn_box').data('event_time'));
        req_time.setSeconds(req_time.getSeconds() + diff);

        request_video_time = req_time.getFullYear() + '-'
                + ('0' + (req_time.getMonth() + 1)).slice(-2) + '-'
                + ('0' + req_time.getDate()).slice(-2) + ' '
                + ('0' + req_time.getHours()).slice(-2) + ':'
                + ('0' + req_time.getMinutes()).slice(-2) + ':'
                + ('0' + req_time.getSeconds()).slice(-2);
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'id',value:$('#request_btn_box').data('warning_id')},
            {name:'request_video_time',value:request_video_time},
        ];
        $.ajax({
            url: $('#request_btn_box').data('action'),
            type:'post',
            dataType: 'json',
            headers: {
                'X-CSRF-TOKEN': $('input[name="_token"]').val()
            },
            data : datas,
            success: function(data, status, xhr) {
                toastr.success(data.message);
            },
            error: function(xhr) {
                error_message = xhr.responseJSON.error ? xhr.responseJSON.error : '動画要求を実行できませんでした。';
                toastr.error(error_message);
            }
        });

        return false;
    }

    // モーダル内動画ダウンロード
    $(document).on('click', '#modal_download_video_button', function () {
        if($('input[name="holding_id"]').length <= 0) {
            toastr.warning('グループ会社が選択されていません。');
        } else {
            // アクションの取得
            let action = extend_url_query($(this).data('action'));
            let id = $(this).data('id');
            // 一覧にあるデータのチェックされたものを配列化する
            let ids = [id];

            let datas = [
                {name:'_token',value:$('input[name="_token"]').val()},
                {name:'holding_id',value:$('input[name="holding_id"]').val()},
                {name:'ids',value:ids},
                {name:'modal_download',value:true}
            ];
            // 送信
            $.ajax({
                url: action,
                type: 'POST',
                data: datas,
                xhrFields: {
                    responseType: 'blob' // レスポンスをBlobとして処理する
                },
                success: function(data, status, xhr) {
                    const disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        const match = disposition.match(/filename\*\s*=\s*UTF-8''(.+?)(?:;|$)/i);
                        const filename = decodeURIComponent(match[1]);
                        const blob = new Blob([data], { type: xhr.getResponseHeader('Content-Type') });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        toastr.error('File download failed.');
                    }
                },
                error: function(jqXHR) {
                    const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                    toastr.error('Error: ' + errorMessage);
                }
            });
        }
    });
}

/* モーダル関連 */
window.record_data_modal_event_set = function (modalId = 'video-modal')
{
    let timeLineVideo;
    let seekSlider;
    let ichi;
    let duration;
    let nowFrame = 0;
    let frameForwardFlg = false;

    // 再生中フラグ
    let isPlaying = false;

    // 音量設定用
    let volumeNum = 25;
    let isMuted = true;

    // メイン表示になっている動画の番号
    let mainViewNum = 1;

    // 現在の再生速度
    let speedNum = 1.0;

    let vehicleData = [];
    let zMapMain;
    let polylineLociLatlon = [];

    let eventOval;

    // Webview用の画面の場合、初期化処理を行う
    if (is_route('api.cm.rollcall.get_warning_video_html')) {
        setUp();
    }

    // 動画リストを表示するボタン
    $(document).on('click','.warning-list-toggle', function() {
        $('.warning-list-box').toggle();
        let text = $(this).data('text');
        $(this).data('text', $(this).text());
        $(this).text(text);
    });

    // 動画一覧の選択が変更されたらモーダルの内容を更新する
    // 読み込み中は次の選択を送信しない（サーバ側の動画変換が同時に走るのを防ぐ）
    let isWarningListLoading = false;
    $(document).on('change','.warning-list', function() {
        if (isWarningListLoading) return;
        isWarningListLoading = true;
        let selectedOption = $(this).find('option:selected');
        let action = selectedOption.data('action');
        let datas = [
            { name: "record_id", value: selectedOption.data('record_id') },
            { name: "warning_id", value: selectedOption.data('warning_id') }
        ];
        _modal.update(modalId, action, datas, true, function(){
            isWarningListLoading = false;
            setUp();
        }, function(){
            isWarningListLoading = false;
        });
    });

    // 動画再生ボタン
    $(document).on('click','#video-play', function() {
        // play() 中に pause() / DOM 除去で race した場合の AbortError は仕様上の正常応答のため握りつぶす。それ以外のエラー型は通知する
        var swallowAbort = function(err) {
            if (err && err.name !== 'AbortError') {
                console.error(err);
            }
        };
        // 全てのvideoを再生する
        $('.in-vehicle-video').each(function(){
            if (!isPlaying) {
                var p = this.play();
                if (p && typeof p.catch === 'function') p.catch(swallowAbort);
            }
        });
        // Audioタグがある場合にはAudioタグも再生
        if($('#in-vehicle-audio').length) {
            var ap = $('#in-vehicle-audio')[0].play();
            if (ap && typeof ap.catch === 'function') ap.catch(swallowAbort);
        }
        isPlaying = true;
        $('#video-play').css({'display' : 'none'});
        $('#video-pause').css({'display': 'inline-block'});
    });


    // 動画一時停止ボタン
    $(document).on('click','#video-pause', function() {
        // 全てのvideoを一時停止する
        $('.in-vehicle-video').each(function(){
            if (isPlaying) {
                this.pause();
            }
        });
        // Audioタグがある場合にはAudioタグも再生
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].pause();
        }
        isPlaying = false;
        $('#video-pause').css({'display' : 'none'});
        $('#video-play').css({'display': 'inline-block'});
    });

    // 動画時間、現在時間の表示やスライダーの動作関係など
    $(document).off('shown.bs.modal', '#' + modalId);
    $(document).on('shown.bs.modal', '#' + modalId, function () {
        let alertMessage = $('#alert_message');
        if(alertMessage !== undefined && alertMessage.length > 0) {
            alert($('#alert_message').val());
            _modal.hide('#' + modalId);
        } else {
            setUp();
        }
    });

    // 音声ONボタン
    $(document).on('click','#video-sound-on', function() {
        //音量スライダーの値を設定
        $('#sound-seek-slider').val(volumeNum);
        // 全てのvideoのミュートを取り消す
        $('.in-vehicle-video').each(function(){
            // videoのvolumeは0~1の間でセットするため、100で割った数値をセット
            this.volume  = volumeNum/100;
            this.muted = false;
        });
        // Audioタグがある場合にはAudioタグにも音量を設定
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].volume  = volumeNum/100;
            $('#in-vehicle-audio')[0].muted = false;
        }
        isMuted = false;
        //サウンドボタンの入れ替え
        $('#video-sound-on').css({'display' : 'none'});
        $('#video-sound-off').css({'display': 'inline-block'});
    });

    // 音声OFFボタン
    $(document).on('click','#video-sound-off', function() {
        //音量スライダーの値を設定
        $('#sound-seek-slider').val(0);
        // 全てのvideoをミュートにする
        $('.in-vehicle-video').each(function(){
            this.muted = true;
        });
        // Audioタグがある場合にはAudioもミュートにする
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].muted = true;
        }
        isMuted = true;
        //サウンドボタンの入れ替え
        $('#video-sound-off').css({'display' : 'none'});
        $('#video-sound-on').css({'display': 'inline-block'});
    });

    // 音量スライダーを操作したら動画に音量を設定
    $(document).on('input', '#sound-seek-slider', function() {
        volumeNum = $('#sound-seek-slider').val();
        isMuted = false;
        $('.in-vehicle-video').each(function(){
            this.volume = volumeNum/100;
            this.muted = false;
        });
        // Audioタグがある場合にはAudioタグにも音量を設定
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].volume = volumeNum/100;
            $('#in-vehicle-audio')[0].muted = false;
        }
        if(isMuted == true) {
            $('#video-sound-on').css({'display' : 'none'});
            $('#video-sound-off').css({'display': 'inline-block'});
        }
        isMuted = false;
    });

    // ビデオ用モーダルを閉じた際に動画を止める
    $(document).on('click', '#' + modalId + ' .close', function () {
        $('.in-vehicle-video').each(function(){
            if (isPlaying) {
                this.pause();
            }
        });
        frameForwardFlg = false;
        isPlaying = false;
    });

    // カメラ切り替えボタン
    $(document).on('click', '.camera-select-btn' ,function (e) {
        /*---- BS-3868_arata START ----*/
        // 無効化されたボタンはクリックできないようにする
        if ($(this).prop('disabled')) {
            return false;
        }
        /*---- BS-3868_arata END ----*/
        let selectNum = $(this).data('camera-num');
        let mainVideo = $('#main-video')[0];
        let subVideo = $('#sub-video'+selectNum)[0];
        if(selectNum != mainViewNum) {
            // 変更する動画のsrcを取得
            let subSource = $(subVideo).find('source').attr('src');
            // メインビューに選択した動画のsrcをセットし、表示する動画の番号をクラスとして付与
            $(mainVideo).find('source').attr('src', subSource);
            $(mainVideo).removeClass('sub-video'+mainViewNum).addClass('sub-video'+selectNum);
            // 選択したサブ動画を強調表示
            $('#sub-video'+selectNum).addClass('selected_video');
            // メインに表示されていたサブ動画の強調表示を削除
            $('#sub-video'+mainViewNum).removeClass('selected_video');
            // 現在メインに表示している動画番号を保持しておく
            mainViewNum = selectNum;
            // メインビューの動画を再ロードする
            mainVideo.load();
            // 再生中だった場合にはメイン動画と表示したサブ動画を再生する
            if (isPlaying) {
                // 現在の描画時間を設定する
                $('#sub-video'+mainViewNum)[0].currentTime = timeLineVideo[0].currentTime;
                mainVideo.currentTime = timeLineVideo[0].currentTime;
                $('#sub-video'+mainViewNum)[0].play();
                mainVideo.play();
            }
            // 現在のボタンを示すクラスを選択したボタンに付与する。
            $('.camera-select-container button').removeClass('btn-primary').addClass('btn-default');
            $(this).removeClass('btn-default').addClass('btn-primary');
        }
    });

    // 再生スピードを指定します（表示調整も含め）
    $(document).on('click', '.speed-select-btn' ,function (e) {
        let playbackRate = $(this).data('speedNum');
        // コマ送り
        if(playbackRate == 0 ){
            if(!frameForwardFlg) {
                let f = Math.floor(timeLineVideo[0].currentTime * 1000) / 1000;
                nowFrame = Math.floor((f / 33.3333333333) * 1000);
            }
            frameForwardFlg = true;
            nowFrame++;
            let nextKeyFrame = (nowFrame * 33.3333333333) / 1000;
            $('.in-vehicle-video').each(function(){
                if (isPlaying) {
                    this.pause();
                }
                this.currentTime = nextKeyFrame;
                this.playbackRate = playbackRate;
            });
            // Audioタグがある場合にはAudioタグの速度も変更
            if($('#in-vehicle-audio').length) {
                $('#in-vehicle-audio')[0].currentTime = nextKeyFrame;
                $('#in-vehicle-audio')[0].playbackRate = playbackRate;
            }
            f = Math.floor( timeLineVideo[0].currentTime * 1000 ) / 1000;
            setMovieTime2(f);
            /** 表示は一時停止のまま再設定しなおす */
            $('#video-play').css({'display' : 'none'});
            $('#video-pause').css({'display': 'inline-block'});
            isPlaying = false;
        }else{
            frameForwardFlg = false;
            $('.in-vehicle-video').each(function(){
                this.playbackRate = playbackRate;
            });
            if(!isPlaying) {
                $('#video-pause').css({'display' : 'none'});
                $('#video-play').css({'display': 'inline-block'});
            }
            // Audioタグがある場合にはAudioタグの速度も変更
            if($('#in-vehicle-audio').length) {
                $('#in-vehicle-audio')[0].playbackRate = playbackRate;
            }
        }
        speedNum = playbackRate;
        $('.speed-select-container button').removeClass('btn-primary').addClass('btn-default');
        $(this).removeClass('btn-default').addClass('btn-primary');
    });

    /**
     * シークバーの位置を設定します。
     * @param {*} f
     */
    function setMovieTime2(f){
        ichi.html(makeMovieTime(f));
    }

    /**
     * 時間（秒数）から、時：分：秒　表記に変更します。
     * @param {*} v
     */
    function makeMovieTime(v){
        let m   = Math.floor(v / 60);
        let s   = ("00" + Math.floor(v - (m * 60))).slice(-2);
        let ret = m + ":" + s;
        if(m >= 60){
            h   = Math.floor(m / 60);
            m   = ("00" + Math.floor(m - (h * 60))).slice(-2);
            ret = h + ":" + m + ":" + s;
        }
        return ret;
    }

    //
    function setUp() {
        vehicleData = $('.zdc-map').data('vehicle_data');
        timeLineVideo = $('#timeline-video');
        seekSlider = $('#video-seek-slider');
        ichi = $("#ichi");
        duration = $('#nagasa').data('duration');
        // スライダーの最大値を設定
        seekSlider.attr('max', duration);
        //スライダーのstep値を設定
        seekSlider.attr('step', duration/1000);
        // 動画時間を分：秒の形式で表示
        $("#nagasa").html(makeMovieTime(Math.floor( duration * 1000 ) / 1000));
        /*---- BS-3868_arata START ----*/
        /*---- カメラボタンの有効/無効を設定 ----*/
        // 各カメラの動画が存在するかチェック
        for (let i = 1; i <= 5; i++) {
            let subVideo = $('#sub-video' + i);
            let source = subVideo.find('source');
            let src = source.attr('src');
            let cameraBtn = $('#camera-select-btn' + i);
            
            // 動画が存在しない場合（srcが空または'empty'）、ボタンを無効化
            if (!src || src === '' || src === 'empty') {
                cameraBtn.prop('disabled', true);
                cameraBtn.addClass('disabled');
            } else {
                cameraBtn.prop('disabled', false);
                cameraBtn.removeClass('disabled');
            }
        }
        /*---- BS-3868_arata END ----*/

        /*---- 地図初期化 ----*/
        zMapMain = $('#' + modalId).find('.zdc-map');
        // modal内の要素の幅、高さを正確に取得するため、モーダル生成1秒後に処理を開始する
        window.setTimeout(function () {
            let options = {
                addressOfMarker: false,
                zoom: 11,
            };
            if (zMapMain.length > 0) {
                //地図を作成
                zMapMain.attr('width', zMapMain.width() + 'px');
                zMapMain.attr('height', zMapMain.height() + 'px');
                if (zMapMain.data('zip_lat') !== '' || zMapMain.data('zip_lon') !== '') {
                    options.lat = zMapMain.data('zip_lat');
                    options.lon = zMapMain.data('zip_lon');
                }
                _zdcMap.Map.init(zMapMain, options, false);
                if(vehicleData.length > 0) {
                    //地図上に経路の線を引く
                    $.each(vehicleData, function(i, item){
                        polylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
                    });
                    polylineLoci = new ZDC.Polyline(
                        polylineLociLatlon,
                        {
                            strokeWeight: 3,
                            strokeColor: '#669DF6'
                        }
                    )
                    _zdcMap._zMap.addWidget(polylineLoci);

                    //地図上に開始地点を示すマーカーを描く
                    currentMarker = new ZDC.Marker(
                        new ZDC.LatLon(vehicleData[0].latitude, vehicleData[0].longitude),
                        {
                            offset: new ZDC.Pixel(-25, -25),
                            custom: {
                                base: {
                                    src: '/assets/img/record_data/vehicle_icon.png',
                                }
                            }
                        }
                    );
                    _zdcMap._zMap.addWidget(currentMarker);
                }
            }
        }, 1000);
        timeLineVideo.on('timeupdate', function() {
            // 動画の現在時間が更新されたらスライダーを更新
            seekSlider.val(timeLineVideo[0].currentTime);
            // 動画の現在時間が更新されたら現在時間の内容を更新
            ichi.html(makeMovieTime(Math.floor( timeLineVideo[0].currentTime * 1000 ) / 1000));
            if(vehicleData != undefined && vehicleData.length > 0 && typeof currentMarker !== 'undefined' && currentMarker) {
                let currentFrame = Math.floor((timeLineVideo[0].currentTime / duration) * vehicleData.length);
                //地図移動
                if (currentFrame >= 0 && currentFrame < vehicleData.length) {
                    let currentPosition = vehicleData[currentFrame];
                    //地図の中心を移動
                    _zdcMap.Map.moveLatlon(currentPosition.latitude, currentPosition.longitude);
                    //車両の位置を示す円を移動

                    currentMarker.moveLatLon(new ZDC.LatLon(currentPosition.latitude, currentPosition.longitude));
                }
            }
        });

        // スライダーを操作したら動画の再生位置を更新
        seekSlider.on('input', function() {
            $('.in-vehicle-video').each(function(){
                this.currentTime = seekSlider.val();
            });
            // Audioタグがある場合にはAudioタグの速度も変更
            if($('#in-vehicle-audio').length) {
                $('#in-vehicle-audio')[0].currentTime = seekSlider.val();
            }
        });

        // 動画が終了した際の処理
        timeLineVideo[0].addEventListener("ended", function(){
            frameForwardFlg = false;
            isPlaying = false;
            $('#video-pause').css({'display' : 'none'});
            $('#video-play').css({'display': 'inline-block'});
        }, false);
    }
}
